<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header class="delete-fax-modal__header">Attention!</h1>

  <div class="delete-fax-modal">
    <p class="delete-fax-modal__question">You are deleting fax</p>

    <p class="delete-fax-modal__question">Are you sure?</p>

    <div class="delete-fax-modal__actions">
      <button class="btn_secondary btn_lg" (click)="onClose()">No</button>
      <button class="btn_primary btn_lg" (click)="onSubmit()">Yes</button>
    </div>
  </div>
</app-base-modal>
